import {
  TimeOffIcon_default
} from "./chunk-E24AIEQE.mjs";
export {
  TimeOffIcon_default as default
};
